var alertHistoryList = {
	actions: "Acties",
	caption: "Alarmgeschiedenis",
	noResultsMessage: "Geen resultaten gevonden",
	alert: {
		date: "Alarmdatum",
		time: "Time",
		trigger: "Alarmprijs",
		limitType: "Limit type",
		limitAbove: "Upper limit",
		limitBelow: "Lower limit"
	},
	security: {
		name: "Naam",
		isin: "ISIN",
		lastPrice: "Laatste prijs",
		lastPriceDateTime: "Datum/Tijd",
		assetClass: "Activaklasse",
		exchange: "Markt"
	}
};
var nl = {
	alertHistoryList: alertHistoryList
};

export { alertHistoryList, nl as default };
